import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueRx from "vue-rx";
import { Subject } from "rxjs";

Vue.config.productionTip = false;

Vue.use(VueRx, Subject);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
